var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-skeleton-root mb-2",class:{ 'row-round': _vm.rounded }})}
var staticRenderFns = []

export { render, staticRenderFns }